import { render, staticRenderFns } from "./orderDetail2.vue?vue&type=template&id=4b01107e&scoped=true&"
import script from "./orderDetail2.vue?vue&type=script&lang=js&"
export * from "./orderDetail2.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail2.vue?vue&type=style&index=0&id=4b01107e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01107e",
  null
  
)

export default component.exports